// RASCUNHOS-NAVEGADOR (I.176): rascunhos e caches do navegador levam empresa + usuário na chave (modelo da importação
// de XML, A-oct.9) e são apagados no "Sair". Sem identidade pronta a chave é null: quem usa não lê nem grava nada.
// A fila offline do PDV e os retornos de cartão ficam fora (PDV-FILA-EMPRESA).
export const DRAFT_STORAGE_BASES = [
  'purchase_draft_v1',
  'gonx-purchase-import-draft-v1',
  'gonx-purchase-import-draft-v2',
  'sale_cart_items',
  'sale_cart_customer',
  'pos_cart_items',
  'sales_assistant_draft',
  'offline_products_cache',
  'mapbox_token',
  'customer_draft',
  'rental_draft',
  'customer_registration_request_draft',
  'driver_route_visits',
  'driver_sale_draft',
  'driver_sale_dialog_state',
  'complete_profile_form',
] as const;

export type DraftStorageBase = (typeof DRAFT_STORAGE_BASES)[number];

export function scopedDraftKey(
  base: DraftStorageBase,
  companyId: string | null | undefined,
  userId: string | null | undefined,
): string | null {
  return companyId && userId ? `${base}:${companyId}:${userId}` : null;
}

/** Apaga, nos dois armazenamentos do navegador, as chaves antigas (fixas) e as novas (com empresa e usuário). */
export function clearScopedDrafts(): void {
  const matches = (key: string) =>
    DRAFT_STORAGE_BASES.some(
      (base) => key === base || key.startsWith(`${base}:`) || key.startsWith(`${base}_`),
    );
  for (const getStorage of [() => window.localStorage, () => window.sessionStorage]) {
    try {
      const storage = getStorage();
      Object.keys(storage).filter(matches).forEach((key) => storage.removeItem(key));
    } catch {
      /* armazenamento indisponível — nada a limpar */
    }
  }
}

/** Remove a chave antiga (fixa) de uma base: dono desconhecido não migra (mesma regra do A-oct.9). */
export function removeLegacyDraftKey(base: DraftStorageBase, storage: 'local' | 'session' = 'local'): void {
  try {
    (storage === 'local' ? window.localStorage : window.sessionStorage).removeItem(base);
  } catch {
    /* armazenamento indisponível */
  }
}
